import { memo } from 'react';
import { SkeletonPrice } from 'src/projects/components/SkeletonPrice.tsx';

type Props = {
    /** Draws the subtotal strip, matching whether the real rows show a price at all. */
    withPrice?: boolean;
}

/**
 * Placeholder for a collapsed ProjectSelectionItem, shown while the list of selections is being
 * read. It reuses the item's own layout classes so it occupies the same height as the row that
 * replaces it and the list does not jump.
 */
export const SkeletonSelectionRow = memo(({ withPrice = false }: Props) => (
    <div className="vss-project-selection-item vss-skeleton-selection-row" aria-hidden={true}>
        <div className="vss-project-selection-item__header">
            <div className="vss-project-selection-item__left">
                <div className="vss-project-selection-item__checkbox">
                    <span className="vss-skeleton-selection-row__checkbox"/>
                </div>

                <div className="vss-project-selection-item__title-group">
                    <span className="vss-skeleton-selection-row__title"/>
                    <span className="vss-skeleton-selection-row__subtitle"/>
                </div>
            </div>

            <div className="vss-project-selection-item__details">
                <span className="vss-skeleton-selection-row__icon"/>
                <span className="vss-skeleton-selection-row__icon"/>
            </div>
        </div>

        <div className="vss-project-selection-item__divider">&nbsp;</div>

        {withPrice && (
            <div className="vss-project-selection-item__subtotal">
                <span className="vss-skeleton-selection-row__label"/>
                <SkeletonPrice size="lg"/>
            </div>
        )}
    </div>
));
